import React from 'react';
import PropTypes from 'prop-types';
import {
  RecommendationsPlaceholder
} from '@thd-olt-component-react/recommendations';

const Recommendations = (props) => {
  const schemaTypes = props?.opts?.schemaData?.schemaTypes;

  return (
    <>
      {
        schemaTypes
        && <RecommendationsPlaceholder scheme={schemaTypes} />
      }
    </>
  );
};

Recommendations.displayName = 'EtchRecommendations';

Recommendations.propTypes = {
  opts: PropTypes.shape({
    schemaData: PropTypes.shape({
      schemaTypes: PropTypes.string,
    }),
  })
};

Recommendations.defaultProps = {
  opts: {}
};

export default Recommendations;
